module.exports = __webpack_public_path__ + "media/images/flags/pa-751c8f87270b925c26c412ec7620827f.svg";